module.exports = require("@mui/icons-material/AllInclusive");